import React, { useEffect } from 'react';

import { lokalisation } from '../../helpers/lokalisation';
import { CorrectAnswerContent } from './correct-answer-content';
import {
    CorrectAnswerBody,
    CorrectAnswerContentWrapper,
    CorrectAnswerGuide,
    CorrectAnswerHeader,
    CorrectAnswerWrapper
} from './correct-answer.styled';
import { CorrectAnswerProps } from './correct-answer.types';

export const CorrectAnswer: React.FC<CorrectAnswerProps> = ({
    question, validation
}) => {
    const { labelTxt: { correctAnswerHeader } } = lokalisation();
    const ref = React.useRef<HTMLDivElement>(null);
    const handleAnimationEnd = () => {
        if (ref.current) {
            ref.current.style.willChange = 'auto';
        }
    };

    useEffect(() => {
        if (ref.current) {
            // fix latex rendering inconsistency
            ref.current.style.willChange = 'transform';
        }
    }, []);

    return (
        <CorrectAnswerWrapper
            data-testid={'correct-answer-wrapper'}
            className={'correct-answer-wrapper'}
        >
            <CorrectAnswerGuide imageType={'img'} iconType={'activityGuide'} />
            <CorrectAnswerBody onAnimationEnd={handleAnimationEnd}>
                <CorrectAnswerHeader>{correctAnswerHeader}</CorrectAnswerHeader>
                <CorrectAnswerContentWrapper ref={ref}>
                    <CorrectAnswerContent question={question} validation={validation} />
                </CorrectAnswerContentWrapper>
            </CorrectAnswerBody>
        </CorrectAnswerWrapper>
    );
};
